
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import WebsiteLayout from "./layouts/WebsiteLayout";

import Home from "./pages/Home";
import Loans from "./pages/Loans";
import PortfolioManagement from "./pages/PortfolioManagement";
import Insurance from "./pages/Insurance";
import LendingPartners from "./pages/LendingPartners";
import Contact from "./pages/Contact";
import PartnerOnboarding from "./pages/PartnerOnboarding";
import Calculators from "./pages/Calculators";

function App() {
  return (
    <BrowserRouter>
      <WebsiteLayout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/loans" element={<Loans />} />
          <Route path="/portfolio-management" element={<PortfolioManagement />} />
          <Route path="/insurance" element={<Insurance />} />
          <Route path="/lending-partners" element={<LendingPartners />} />
          <Route path="/partner-onboarding" element={<PartnerOnboarding />} />
          <Route path="/calculators" element={<Calculators />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </WebsiteLayout>
    </BrowserRouter>
  );
}

export default App;
